import React from "react";
import type { AccountData } from "../../../hooks/useMyAccountData";

interface EditAccountModalProps {
  editAccountData: AccountData;
  setEditAccountData: (data: AccountData) => void;
  onClose: () => void;
  handleEditAccount: () => void;
}

const EditAccountModal: React.FC<EditAccountModalProps> = ({
  editAccountData,
  setEditAccountData,
  onClose,
  handleEditAccount,
}) => (
  <div
    className="modal-overlay"
    data-testid="edit-account-modal-overlay"
    onClick={onClose}
  >
    <div
      className="modal-content"
      data-testid="edit-account-modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-header" data-testid="edit-account-modal-header">
        <h3>Edit Account Details</h3>
        <button
          className="close-button"
          data-testid="edit-account-modal-close-button"
          onClick={onClose}
        >
          ✕
        </button>
      </div>
      <div className="modal-body" data-testid="edit-account-modal-body">
        <div className="form-group">
          <label>Services</label>
          <input
            type="text"
            data-testid="edit-account-services-input"
            value={editAccountData.services}
            onChange={(e) =>
              setEditAccountData({
                ...editAccountData,
                services: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="modal-footer" data-testid="edit-account-modal-footer">
        <button
          className="action-button secondary"
          data-testid="edit-account-modal-cancel-button"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="action-button primary"
          data-testid="edit-account-modal-save-button"
          onClick={handleEditAccount}
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
);

export default EditAccountModal;
